import { Locale as t } from "../../constants/locale.js";
import { createStrictContext as m } from "../../util/context/createStrictContext.js";
import { underscoreLocale as u } from "../../util/i18n/helper/locale.js";
import { useRouter as l } from "next/router";
import * as i from "ramda";
import { useMemo as g, useState as f } from "react";
import { jsx as p } from "react/jsx-runtime";
const [L, j] = m("Language"), R = (r) => {
  const {
    children: a
  } = r, {
    locale: o
  } = l(), n = g(() => {
    const e = u(o || "");
    return i.includes(e, Object.values(t)) ? e : t.English;
  }, [o]), [c, s] = f(n);
  return /* @__PURE__ */ p(L, {
    value: {
      language: c,
      setLanguage: s
    },
    children: a
  });
};
export {
  R as LanguageProvider,
  j as useLanguageContext
};
//# sourceMappingURL=LanguageContext.js.map
